module.exports = __webpack_public_path__ + "img/shipped-icon.a7506d5c.svg";